import { forwardRef, type Ref, type SVGProps } from "react";
const IconSearchFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M29.41 26.59 23.77 21A12 12 0 0 0 14 2h-1A11 11 0 0 0 2 13v1a12 12 0 0 0 19 9.77l5.64 5.64a2 2 0 0 0 2.82-2.82ZM14 22a8 8 0 1 1 8-8 8 8 0 0 1-8 8"
    />
  </svg>
);
const ForwardRef = forwardRef(IconSearchFilledSVG);
ForwardRef.displayName = "IconSearchFilled";
export { ForwardRef as IconSearchFilled };
